import { Component, Input } from '@angular/core';
import { FeedbackService } from '../../../../models/feedback/feedbackService';
import { UIFeedback } from '../../../../models/feedback/uiFeedback';

@Component({
  selector: 'app-feature-feedback-component',
  templateUrl: './feature-feedback-component.component.html',
  standalone: false,
})
export class FeatureFeedbackComponentComponent {
  @Input() featureName: string = '';

  isHelpful: string = '';
  thoughts: string = '';
  submitted: boolean = false;

  feedback: Partial<UIFeedback> = {};

  constructor(private feedbackService: FeedbackService) {
    this.feedback = new UIFeedback({ featureName: this.featureName });
  }

  ngOnInit() {
    this.feedback = new UIFeedback({ featureName: this.featureName });
  }

  btnSubmit_click() {
    //let feedback = new UIFeedback({isHelpful: this.isHelpful, thoughts: this.thoughts})

    this.feedbackService.postFeedback(this.feedback).then(() => {
      this.submitted = true;
    });
  }
}
